//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/public'
import pagination from '@/common/mixins/pagination'
import call_consultant from '@/common/mixins/callConsultant'
import open_chat from '@/common/mixins/open_chat'
import BottomTip from '@/components/views/bottom_tip'
export default {
    components: {
        BottomTip
    },
    mixins: [
        pagination,
        call_consultant,
        open_chat
    ],
    data () {
        return {
            per: 10,
            date_sections: [],
            total_count: 0
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        async getData () {
            const data = await Service.getPhoneCall({
                per: this.per,
                page: this.page
            })
            this.handleData(data)
            const current_date = new Date()
            const current_year = current_date.getFullYear()
            const current_month = current_date.getMonth() + 1
            this.total_count = data.total_count
            const month_data = this.items.reduce((sections, item) => {
                const date = new Date(item.call_date)
                const year = date.getFullYear()
                let month = date.getMonth() + 1
                if (year === current_year) {
                    if (current_month === month) {
                        month = '本月'
                    } else {
                        month = `${month}月`
                    }
                } else {
                    month = `${current_year}年${month}月`
                }
                if (sections[month]) {
                    sections[month].push(item)
                } else {
                    sections[month] = [item]
                }
                return sections
            }, {})
            this.date_sections = Object.keys(month_data).map((month) => {
                return {
                    month,
                    items: month_data[month]
                }
            })
        }
    }
}
